export default __webpack_public_path__ + "static/media/infotip.39441d92.svg";